import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { UPGRADE_SUBSCRIPTION_URL } from '../../../../config/constants';
import { useTranslate } from '@tolgee/react';

export interface UpgradeRequiredTooltipWrapper1Props {
  /** Whether the tooltip should be visible */
  show: boolean;

  /** Child element that triggers the tooltip */
  children: React.ReactElement;
}

/**
 * Atoms: UpgradeRequiredTooltipWrapper
 *
 * Wraps a child element with a tooltip prompting the user to upgrade
 * when a feature is unavailable.
 */
const UpgradeRequiredTooltipWrapper1: React.FC<
  UpgradeRequiredTooltipWrapper1Props
> = ({ show, children }) => {
  const { t } = useTranslate();

  return (
    <OverlayTrigger
      delay={{ show: 10, hide: 1000 }}
      placement="auto"
      overlay={
        show ? (
          <Tooltip id="tooltip-upgrade-required">
            <div>
              {t('lomavisCreator.multipostSettings.featureNotAvailable')}
            </div>

            <div className="w-100 mt-2 text-end">
              <a
                href={UPGRADE_SUBSCRIPTION_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-nowrap"
              >
                {t('lomavisCreator.multipostSettings.upgradeNow')}
              </a>
            </div>
          </Tooltip>
        ) : (
          <></>
        )
      }
    >
      <div className="position-relative d-inline-block">
        {children}

        {show && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background: 'transparent',
              cursor: 'not-allowed',
              zIndex: 2
            }}
          />
        )}
      </div>
    </OverlayTrigger>
  );
};

export default UpgradeRequiredTooltipWrapper1;
